export default {
    setPlatformApprovalData(state, value) {
        state.approvalData = value;
    },
};
